import React, {useCallback} from 'react';

import {MAX_COL_COUNT} from '../../../../PanelMediaBrowser/config';
import {SettingsSliderInput} from '../common/SettingsSliderInput';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const NumberOfColumns = () => {
  const {config, updateConfig} = useMediaSettingsDrawerContext();
  const initialValue = config.columnCount;

  // Debounce the updateConfig call so we don't update on every keystroke or slider change
  const updateConfigCallback = useCallback(
    (value: number) => {
      updateConfig({columnCount: value});
    },
    [updateConfig]
  );

  return (
    <div className="flex flex-col">
      <SettingTitle title="Number of columns" id="number-of-columns-label" />
      <SettingsSliderInput
        initialValue={initialValue}
        updateConfigCallback={updateConfigCallback}
        max={MAX_COL_COUNT}
        data-test="column-count-input"
        aria-labelledby="number-of-columns-label"
      />
    </div>
  );
};
